import React from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from '../navigation/Navbar';
import { Footer } from '../../../features/home/components/Footer';
import { ScrollToTopArrow } from '../navigation/ScrollToTopArrow';
import { isMobile, isTablet } from '../../utils/deviceUtils';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  // Device detection
  const mobile = isMobile();
  const tablet = isTablet();
  const location = useLocation();

  // Check if current page is a hero page that should not have universal padding
  const isHeroPage = () => {
    const heroPaths = [
      '/', // Home page
      '/about',
      '/contact',
      '/blog',
      '/destinations',
      '/safaris-search',
      '/transport-search',
    ];
    
    return heroPaths.includes(location.pathname);
  };

  // Only apply universal padding on mobile/tablet for non-hero pages
  const shouldApplyPadding = (mobile || tablet) && !isHeroPage();

  return (
    <div className="min-h-screen">
      {/* Navbar is fixed and transparent, content flows under it */}
      <Navbar />
      <main className={`min-h-screen ${shouldApplyPadding ? 'pt-16' : ''}`}>
        {/* Each page will have its own hero section that sits behind the transparent navbar */}
        {children}
        <Footer />
      </main>
      <ScrollToTopArrow />
    </div>
  );
};
